// tslint:disable-next-line: no-magic-numbers
export const lineShimmerHeight = 12;

// tslint:disable-next-line: no-magic-numbers
export const defaultLineShimmerWidth = 120;

// tslint:disable-next-line: no-magic-numbers
export type MediaShimmerSizes = 12 | 16 | 32 | 40;
